import * as React from 'react';
import { cx } from 'linaria';

import * as styles from './theme-provider.styles';

export interface ThemeProviderProps extends React.HTMLAttributes<HTMLDivElement> {
    /**
     *  Theme mode for components wrapper under ThemeProvider
     *  @default dark
     */
    theme?: 'light' | 'dark';
    /**
     * Test id for unit and E2E
     */
    testId?: string;
}

const ThemeContext = React.createContext<ThemeProviderProps['theme']>(null);

ThemeContext.displayName = 'ThemeContext';

export const ThemeProvider = React.forwardRef<HTMLDivElement, ThemeProviderProps>((props, ref) => {
    const { children, theme = 'dark', testId, ...passThroughProps } = props;

    const className = cx(passThroughProps.className, styles.root);

    return (
        <ThemeContext.Provider value={theme}>
            <div {...passThroughProps} ref={ref} className={className} data-testid={testId} data-theme={theme}>
                {children}
            </div>
        </ThemeContext.Provider>
    );
});

ThemeProvider.displayName = 'ThemeProvider';

export const useTheme = (): ThemeProviderProps['theme'] => {
    const theme = React.useContext(ThemeContext);

    return theme;
};
